import { render } from "./padel-timepicker.template.html?vue&type=template&id=c007e094&scoped=true"
import script from "./PadelTimepicker.vue?vue&type=script&lang=ts"
export * from "./PadelTimepicker.vue?vue&type=script&lang=ts"

import "./PadelTimepicker.vue?vue&type=style&index=0&id=c007e094&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c007e094"

export default script